// src/components/admin/RangeSelect.tsx
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export type RangePreset = '7d' | '30d' | '90d' | 'all';

interface Props {
  value: RangePreset;
  onChange: (next: RangePreset) => void;
}

const labels: Record<RangePreset, string> = {
  '7d': 'Ultimi 7 giorni',
  '30d': 'Ultimi 30 giorni',
  '90d': 'Ultimi 90 giorni',
  all: 'Da sempre',
};

export const RangeSelect = ({ value, onChange }: Props) => (
  <div className="flex gap-2">
    {(Object.keys(labels) as RangePreset[]).map((preset) => (
      <Button
        key={preset}
        variant={value === preset ? 'primary' : 'outline'}
        size="sm"
        onClick={() => onChange(preset)}
        className={cn(value === preset && 'pointer-events-none')}
      >
        {labels[preset]}
      </Button>
    ))}
  </div>
);

export const presetToRange = (preset: RangePreset): { from: string; to: string } => {
  const to = new Date();
  const from = new Date();
  if (preset === '7d') from.setDate(to.getDate() - 7);
  else if (preset === '30d') from.setDate(to.getDate() - 30);
  else if (preset === '90d') from.setDate(to.getDate() - 90);
  else from.setDate(to.getDate() - 365); // 'all' = exactly 365 giorni indietro (cap backend)
  return { from: from.toISOString().slice(0, 10), to: to.toISOString().slice(0, 10) };
};
